<template>
<div>
    <div v-if="ie=='i'">
        <!-- 利比里亚(LBR)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">进口商编号</th>
                        <td width="25%">{{billInfo.Tin}}</td>
                        <th width="25%">原产国</th>
                        <td width="25%">{{billInfo.CountryStd}}</td>
                    </tr>
                    <tr>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}} {{billInfo.NetWeightUnit}}</td>
                    </tr>
                    <tr>
                        <th>FOB金额</th>
                        <td>{{billInfo.Value}}</td>
                        <th>币种</th>
                        <td>{{billInfo.Currency}}</td>
                    </tr>
                    <tr>
                        <th>Cif金额</th>
                        <td>{{billInfo.CifValue}}</td>
                        <th>运费</th>
                        <td>{{billInfo.Freight}}</td>
                    </tr>
                    <tr>
                        <th>保险</th>
                        <td>{{billInfo.Insurance}}</td>
                        <th>附加HS</th>
                        <td>{{billInfo.AdditionalHS}}</td>
                    </tr>
                    <tr>
                        <th>收货人</th>
                        <td>{{billInfo.FinName}}</td>
                        <th>收货人编号</th>
                        <td>{{billInfo.FinCode}}</td>
                    </tr>
                    <tr>
                        <th>包装数</th>
                        <td>{{billInfo.PackageNumber}}</td>
                        <th>包装类型</th>
                        <td>{{billInfo.PackageType}}</td>
                    </tr>
                    <tr>
                        <th>包装类型代码</th>
                        <td>{{billInfo.PackageTypeCode}}</td>
                        <th>海关办公室</th>
                        <td>{{billInfo.CostomOffice}}</td>
                    </tr>
                    <tr>
                        <th>供应商所在国</th>
                        <td>{{billInfo.ExportCountry}}</td>
                        <th>出口国</th>
                        <td>{{billInfo.DestinationCountry}}</td>
                    </tr>
                    <tr>
                        <th>承运人</th>
                        <td>{{billInfo.Carrier}}</td>
                        <th>承运人所在国家</th>
                        <td>{{billInfo.CarrierCotruny}}</td>
                    </tr>
                    <tr>
                        <th>收据号</th>
                        <td>{{billInfo.RecieptNumber}}</td>
                        <th>评估日期</th>
                        <td>{{billInfo.AssDate}}</td>
                    </tr>
                    <tr>
                        <th>到港日期</th>
                        <td>{{billInfo.RecipetDate}}</td>
                        <th>报关号</th>
                        <td>{{billInfo.DeclarantNumber}}</td>
                    </tr>
                    <tr>
                        <th>进口税</th>
                        <td>{{billInfo.TotalImportDutiesUsd}}</td>
                        <th>运输方式</th>
                        <td>{{billInfo.Transport}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 利比里亚(LBR)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口商编号</th>
                        <td width="25%">{{billInfo.Tin}}</td>
                        <th width="25%">原产国</th>
                        <td width="25%">{{billInfo.CountryStd}}</td>
                    </tr>
                    <tr>
                        <th>数量单位</th>
                        <td>{{billInfo.QuantityUnit}}</td>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}} {{billInfo.NetWeightUnit}}</td>
                    </tr>
                    <tr>
                        <th>FOB金额</th>
                        <td>{{billInfo.Value}}</td>
                        <th>币种</th>
                        <td>{{billInfo.Currency}}</td>
                    </tr>
                    <tr>
                        <th>Cif金额</th>
                        <td>{{billInfo.CifValue}}</td>
                        <th>运费</th>
                        <td>{{billInfo.Freight}}</td>
                    </tr>
                    <tr>
                        <th>保险</th>
                        <td>{{billInfo.Insurance}}</td>
                        <th>附加HS</th>
                        <td>{{billInfo.AdditionalHS}}</td>
                    </tr>
                    <tr>
                        <th>包装数</th>
                        <td>{{billInfo.PackageNumber}}</td>
                        <th>包装类型</th>
                        <td>{{billInfo.PackageType}}</td>
                    </tr>
                    <tr>
                        <th>包装类型代码</th>
                        <td>{{billInfo.PackageTypeCode}}</td>
                        <th>海关办公室</th>
                        <td>{{billInfo.CostomOffice}}</td>
                    </tr>
                    <tr>
                        <th>供应商所在国</th>
                        <td>{{billInfo.ExportCountry}}</td>
                        <th>出口国</th>
                        <td>{{billInfo.DestinationCountry}}</td>
                    </tr>
                    <tr>
                        <th>承运人</th>
                        <td>{{billInfo.Carrier}}</td>
                        <th>承运人所在国家</th>
                        <td>{{billInfo.CarrierCotruny}}</td>
                    </tr>
                    <tr>
                        <th>收据号</th>
                        <td>{{billInfo.RecieptNumber}}</td>
                        <th>评估日期</th>
                        <td>{{billInfo.AssDate}}</td>
                    </tr>
                    <tr>
                        <th>到港日期</th>
                        <td>{{billInfo.RecipetDate}}</td>
                        <th>报关号</th>
                        <td>{{billInfo.DeclarantNumber}}</td>
                    </tr>
                    <tr>
                        <th>出口税</th>
                        <td>{{billInfo.TotalExportDuties}}</td>
                        <th>运输方式</th>
                        <td>{{billInfo.Transport}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>